"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsMenuNavegation = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _dmsbasereact = require("dmsbasereact");
var _system = require("@mui/system");
var _DmsButtonNavigate = require("../DmsButtonNavigate/DmsButtonNavigate");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const DmsMenuNavegation = _ref => {
  let {
    title = _dmsbasereact.intl.get('Actions').d('Actions'),
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Card, null, /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Header, null, /*#__PURE__*/_react.default.createElement(_material.Typography, null, title)), /*#__PURE__*/_react.default.createElement(_dmsbasereact.DmsAltBox.Body, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2
    }
  }, children));
};
exports.DmsMenuNavegation = DmsMenuNavegation;
DmsMenuNavegation.propTypes = {
  children: _propTypes.default.node.isRequired
};
DmsMenuNavegation.Item = _ref2 => {
  let {
    text,
    icon,
    route,
    color,
    customStyles
  } = _ref2;
  const baseColor = color || styles.button.backgroundColor;
  const hoverColor = (0, _system.darken)(baseColor, 0.2);
  return /*#__PURE__*/_react.default.createElement(_DmsButtonNavigate.DmsButtonNavigate, {
    route: route,
    text: text,
    startIcon: icon,
    sx: _objectSpread(_objectSpread({}, styles.button), {}, {
      backgroundColor: baseColor,
      '&:hover': {
        backgroundColor: hoverColor
      }
    }, customStyles || {})
  });
};
DmsMenuNavegation.Item.propTypes = {
  text: _propTypes.default.string.isRequired,
  icon: _propTypes.default.node,
  route: _propTypes.default.string.isRequired,
  color: _propTypes.default.string,
  customStyles: _propTypes.default.object
};
const styles = {
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    textAlign: 'center',
    backgroundColor: '#3c8dbc',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#2a6f9b'
    }
  }
};